// extracted by mini-css-extract-plugin
module.exports = {"itemsContainer":"styles_itemsContainer__2eD4t"};